import BaseValidator from 'ember-cp-validations/validators/base';

function recordsFor(relation) {
  if (!relation) {
    return [];
  }

  if (typeof relation.toArray === 'function') {
    return relation.toArray();
  }

  if (typeof relation[Symbol.iterator] === 'function') {
    return Array.from(relation);
  }

  if (typeof relation.length === 'number') {
    return Array.from({ length: relation.length }, (_, index) => {
      return (
        relation.at?.(index) ?? relation.objectAt?.(index) ?? relation[index]
      );
    }).filter(Boolean);
  }

  return [];
}

export default BaseValidator.extend({
  validate(value, options, model, attribute) {
    let duplicates = recordsFor(options.relation).filter(
      (relation) => relation[attribute] == value,
    );

    if (duplicates.length > 1) {
      return this.createErrorMessage('unique-in-relation', value, options);
    }

    return true;
  },
});
